import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { UserProfile } from './user-profile.model';
import * as i0 from "@angular/core";
import * as i1 from "../../core/auth/auth.service";
var InfoProfileService = /** @class */ (function () {
    function InfoProfileService(authService) {
        this.authService = authService;
        this.userSubject = new BehaviorSubject(null);
    }
    InfoProfileService.prototype.getUserProfile = function () {
        if (!this.userInfo)
            this.retrieveUserInformation();
        return this.userSubject.asObservable();
    };
    InfoProfileService.prototype.retrieveUserInformation = function () {
        var _this = this;
        this.authService.getAuthModel().subscribe(function (response) {
            var userName;
            var userPicture;
            if (response) {
                userName = response.name;
                if (!response.picture || response.picture == "") {
                    response.picture = "./assets/img/user_placeholder.PNG";
                }
                userPicture = response.picture;
                _this.userInfo = new UserProfile(userName, userPicture);
                _this.userSubject.next(_this.userInfo);
            }
        }, function (error) {
            console.log(error);
        });
    };
    InfoProfileService.ngInjectableDef = i0.defineInjectable({ factory: function InfoProfileService_Factory() { return new InfoProfileService(i0.inject(i1.AuthService)); }, token: InfoProfileService, providedIn: "root" });
    return InfoProfileService;
}());
export { InfoProfileService };
